var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStickyNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8666 1.59998C2.98295 1.59998 2.2666 2.31632 2.2666 3.19998V12.8C2.2666 13.6836 2.98295 14.4 3.8666 14.4H11.2039C11.6282 14.4 12.0352 14.2314 12.3352 13.9313L14.598 11.6686C14.898 11.3685 15.0666 10.9616 15.0666 10.5372V3.19998C15.0666 2.31632 14.3503 1.59998 13.4666 1.59998H3.8666ZM5.4666 4.79998C5.02477 4.79998 4.6666 5.15815 4.6666 5.59998C4.6666 6.0418 5.02477 6.39998 5.4666 6.39998H11.8666C12.3084 6.39998 12.6666 6.0418 12.6666 5.59998C12.6666 5.15815 12.3084 4.79998 11.8666 4.79998H5.4666ZM4.6666 8.79998C4.6666 8.35815 5.02477 7.99998 5.4666 7.99998H8.6666C9.10843 7.99998 9.4666 8.35815 9.4666 8.79998C9.4666 9.2418 9.10843 9.59998 8.6666 9.59998H5.4666C5.02477 9.59998 4.6666 9.2418 4.6666 8.79998ZM14.2666 10.4H11.4666C11.2457 10.4 11.0666 10.5791 11.0666 10.8V13.6L14.2666 10.4Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyNote);
export default __webpack_public_path__ + "static/media/sticky-note.8f5e4ba7134b3ea9364766b013caff71.svg";
export { ForwardRef as ReactComponent };